import Vue from 'vue'
import VueRouter from 'vue-router';
import router from './routers.js';
import axios from 'axios';
import Qs from 'qs'
import Vuex from 'vuex'
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/style.css';
import App from './App.vue';
import cfg from './cfg.js';
import {
	provinceAndCityData,
	regionData,
	provinceAndCityDataPlus,
	regionDataPlus,
	CodeToText,
	TextToCode
} from 'element-china-area-data';
import format from 'vue-text-format';
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/oa3/pc' : '';
cfg.server = process.env.NODE_ENV === 'production' ? '/' : 'http://192.168.1.156:6030/';
cfg.uploadKey = "45DE2C8746E0C5561E3EE527F79C1F4A";
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
	//在发送请求之前做某件事
	if (config.method === 'post') {
		if (store.state.token) {
			config.headers.Token = store.state.token
			//application/x-www-form-urlencoded
		}
		var timestamp = (new Date()).valueOf();
		config.headers.Timestamp = timestamp;
		config.headers.Version = cfg.version;
		config.headers.Sign = md5(timestamp + cfg.version + cfg.apikey);
		//console.log(config.data)
	}
	return config;
}, (error) => {
	console.log('错误的传参')
	return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(response => {
	// 对响应数据做点什么
	if (typeof response.data != 'object') {
		return ElementUI.MessageBox({
			title: '返回数据格式错误',
			message: response.data ? response.data : '(无返回数据)',
			type: 'error'
		}).then(()=>{
			return Promise.reject(false);
		});
	}
	if (response.data.errcode == 41000) {
		ElementUI.MessageBox({
			title: '请登陆',
			message: response.data.msg,
			type: 'error'
		}).then(()=>{			
			router.push({
				path: '/login',
				query: {
					redirect: router.currentRoute.fullPath
				}
			})
		});
		return Promise.reject(false);
	}
	return response.data;
}, error => {
	// 对响应错误做点什么
	return Promise.reject(error);
});

Vue.prototype.$cfg = cfg;
Vue.prototype.$md5 = md5;
Vue.prototype.$http = axios;
Vue.prototype.$qs = Qs;
Vue.prototype.$regionData = regionData;
Vue.prototype.CodeToText = CodeToText;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(format);
Vue.config.productionTip = false
const LOGIN = 'LOGIN'; // 用常量代替事件类型，使得代码更清晰
const LOGIN_OUt = 'LOGIN_OUT';
const store = new Vuex.Store({
	state: {
		token: null
	},
	mutations: {
		[LOGIN](state, token) { // 第一个参数为 state 用于变更状态 登录
			sessionStorage.setItem("token", token);
			state.token = token;
			router.push(router.history.current.query.redirect ? router.history.current.query.redirect : '/');
		},
		[LOGIN_OUt](state) { // 退出登录
			sessionStorage.removeItem("token");
			state.token = null;
			router.push({
				path: '/login',
				query: {
					redirect: router.history.current.fullPath
				}
			});
		}
	}
});
router.beforeEach((to, from, next) => {
	if (!store.state.token) {
		store.state.token = sessionStorage.getItem('token');
	}
	if (to.meta.requireAuth) {
		if (store.state.token) {
			next();
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 将跳转的路由path作为参数，登录成功后跳转到该路由
			})
		}
	} else {
		next();
	}
	if (to.meta.title) {
		document.title = to.meta.title + " - " + cfg.name
	}
	next()
});
router.afterEach(route => {});
new Vue({
	el: '#app',
	router: router,
	store,
	render: h => h(App)
});
